// eslint-disable-next-line import/no-anonymous-default-export
export default {
    currentCategory: {
        categoryName: "",
        categories: [],
        products: [],
        cart: []
    }
}